import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state, signal, props } from 'cerebral/tags'
import { Tag } from '../Tag'
import { Options } from './Options'
import styles from './styles'
import KeyHandler from './keyHandler'
import Input from './input'

export default connect(
  {
    selected: state`selectr.${props`namespace`}.selected`,
    onFocusInput: signal`selectr.onFocusInput`
  },
  class Select extends Component {
    renderTags() {
      const {
        selected = [],
        namespace,
        overrideStyles,
        editable,
        tagClicked
      } = this.props
      return selected.map((option, index) => {
        const { label, flash, deleteEnter, focused, pinned } = option
        return (
          <Tag
            label={label}
            tagClicked={tagClicked}
            flash={flash}
            deleteEnter={deleteEnter}
            focused={focused}
            overrideStyles={overrideStyles}
            namespace={namespace}
            tagIndex={index}
            key={index}
            pinned={pinned}
            editable={editable}
          />
        )
      })
    }

    render() {
      const { onFocusInput, namespace, overrideStyles, editable } = this.props

      if (editable) {
        let containerStyle = { ...styles.container }
        if (overrideStyles && overrideStyles.container) {
          containerStyle = { ...containerStyle, ...overrideStyles.container }
        }
        return (
          <KeyHandler namespace={namespace}>
            <div
              onClick={e => {
                onFocusInput({ namespace })
              }}
              style={containerStyle}>
              {this.renderTags()}
              <Input overrideStyles={overrideStyles} namespace={namespace} />
            </div>
            <Options overrideStyles={overrideStyles} namespace={namespace} />
          </KeyHandler>
        )
      }

      let containerStyle = { ...styles.noneEditableContainer }
      if (overrideStyles && overrideStyles.noneEditableContainer) {
        containerStyle = {
          ...containerStyle,
          ...overrideStyles.noneEditableContainer
        }
      }
      return <div style={containerStyle}>{this.renderTags()}</div>
    }
  }
)
